import React, { Fragment, useContext, useState, useEffect } from "react"
import Collasable from "../Collasable/Collasable"
import { CommentContext } from "../../providers/CommentProvider"
import CommentCard from "../../components/CommentCard/CommentCard"
import { useParams } from 'react-router-dom';
import CommentList from '../CommentList/CommentList';
import CommentInput from '../CommentInput/CommentInput';
import { Divider, Comment, Avatar } from 'antd';
import { useFirestore } from "reactfire"
import moment from 'moment';
import { UserContext } from '../../providers/UserProvider';

const ResponseComments = (props) => {
    const { style, response, comments, query, project} = props
    const { id } = useParams()
    const firestore = useFirestore()
    const { user } = useContext(UserContext)
    const [sortedComments, setSortedComments] = useState([])

    const addComment = (comment) => {
        query
        .add({
            author: user.name,
            author_initials: user.initials,
            author_color: user.color,
            content: comment,
            datetime: new Date()
        })
        .then(() => {
            console.log("Document written with ID: ", id)
        })
        .catch((error) => {
            console.error("Error updating document: ", error)
        })  
    }

    const loadSortedComments = () => {
        const sorted = comments.sort(function(a,b){
            return new Date(b.datetime.seconds) - new Date(a.datetime.seconds);
        });
        setSortedComments(sorted)
    }

    useEffect(() => {
        loadSortedComments()
    }, [comments])

    return (
        <div id="CommentsResponse" className="ResponseComments" style={style}>
            <Collasable size="small" className={`${project.simile_status != 'Active' ? 'disabled-container' : ''}`} subtitle="Show comments" opened={false} title={`${comments.length} Comments on this Response`}>
                <CommentInput addComment={addComment}/>
                {sortedComments.length > 0 &&
                    <Fragment>
                        <Divider />
                        <CommentList query={query} comments={sortedComments} />
                    </Fragment>
                }
            </Collasable>        
        </div>
    )
}

export default ResponseComments
